import { createTheme } from "@mui/material/styles";
import Colours from "./helpers/colours";

const FONT_SIZE = 16;

export const lightTheme = createTheme({
    palette: {
        type: "light",
        mode: "light",
        primary: {
            main: Colours.primary,
        },
        secondary: {
            main: Colours.secondary,
        },
        error: {
            main: Colours.error,
        },
        warning: {
            main: Colours.warning,
        },
        info: {
            main: Colours.info,
        },
        divider: Colours.divider,
        background: {
            default: Colours.backgroundWhite,
        },
        text: {
            primary: Colours.textColour,
        },
    },
    typography: {
        fontFamily: "Montserrat",
        fontSize: FONT_SIZE,
    },
    components: {
        MuiPickersCalendarHeader: {
            // This is to avoid word break in September 202X in date pickers
            styleOverrides: {
                label: {
                    width: "max-content",
                },
            },
        },
    },
});
